import { gsap, Flip, SplitText, ScrollTrigger } from "../global/gsap";

const initHomeHero = (homeHeroEl) => {
    const logo = homeHeroEl.querySelector(".js-hero-logo");
    const scrollToContent = homeHeroEl.querySelector(".js-scroll-to-content");
    const strapline = homeHeroEl.querySelector(".js-strapline");
    const toolText = homeHeroEl.querySelector(".js-tool-text");
    const details = homeHeroEl.querySelector(".js-details");
    const uiBtns = homeHeroEl.querySelectorAll(".js-ui");
    const navBtns = document.querySelectorAll(".js-nav-btn");
    const plusIcon = logo.querySelector('.plus-icon');

    const split = new SplitText(strapline, { type: "chars" });

    gsap.set(strapline, {
        opacity: 1
    });

    const bbox = plusIcon.getBBox();
    const cx = bbox.x + bbox.width / 2;
    const cy = bbox.y + bbox.height / 2;

    gsap.set(plusIcon, {
        rotation: -90,
        svgOrigin: `${cx} ${cy}`
    });

    // gsap.to(logo, {
    //     opacity: 1,
    //     duration: 0.8,
    //     ease: "power1.out",
    // });

    gsap.set(logo, {
        autoAlpha: 1
    });

    const state = Flip.getState([logo]);

    logo.classList.add("shrink");

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: homeHeroEl,
            start: "top top",
            end: "+=100%",
            pin: true,
            scrub: 1
        },
    });

    tl.add(
        Flip.from(state, {
            duration: 2,
            ease: "none",
            // scale: true,
            // lazy: false
            scale: false,
            simple: true,
        }),
    )
        .to(plusIcon, {
            rotation: 0,
            duration: 2,
            ease: "none",
            svgOrigin: `${cx} ${cy}`
        }, "<") 
        .to(scrollToContent, {
            autoAlpha: 0,
        }, "<")
        .from(split.chars, {
            opacity: 0,
            x: 6,
            stagger: 0.05,
            ease: "power1.out",
            duration: 1,
        }, "-=1",
        )
        .to([toolText, details, uiBtns, navBtns], {
            opacity: 1,
            duration: 1,
            ease: "power1.out",
        }, "-=0.5",
        );

    // scroil button click
    scrollToContent.addEventListener("click", (e) => {
        e.preventDefault();

        gsap.to(window, {
            duration: 1.5,
            scrollTo: tl.scrollTrigger.end,
            ease: "power2.inOut"
        });
    });

    // Progress bars

    const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', () => {
        const dashboards = document.querySelector('.js-listing');

        gsap.to(".progress-bar", {
            scaleX: 1,
            ease: "none",
            scrollTrigger: {
                trigger: "body",
                start: "top top",
                endTrigger: dashboards,
                end: "bottom bottom",
                scrub: 0.3,
                onLeave: () => {
                    gsap.to(".progress-container", {
                        opacity: 0,
                        duration: 0.2,
                        ease: "power2.in"
                    });
                },
                onEnterBack: () => {
                    gsap.to(".progress-container", {
                        opacity: 1,
                        duration: 0.2,
                        ease: "power2.out"
                    });
                }
            }
        });
    });

    

    ScrollTrigger.refresh();
};

export { initHomeHero as default };
